import Cookie from "js-cookie";

export default function () {
	(function ($) {
		$(function () {
			const $modal1 = jQuery(".modal-1");

			if ($modal1.length) {
				$modal1.each(function () {
					const $modal = jQuery(this);
					const modalTrigger = $modal.find(".modal-1__trigger");
					const modalWrapper = $modal.find(".modal-1__wrapper");
					const modalID = $modal.attr("id");
					const cleaningTime = $modal.data("cleaning-time") ? $modal.data("cleaning-time") : -1;
					const closingTime = Cookie.get("dr_modal_closed_" + modalID) ? Cookie.get("dr_modal_closed_" + modalID) : 0;

					if (!closingTime || parseInt(cleaningTime) > parseInt(closingTime)) {
						modalTrigger.addClass("is-active");
						modalWrapper.addClass("is-active");
					}

					modalTrigger.on("click", function () {
						if (modalTrigger.hasClass("is-active")) {
							const d = new Date();
							const UTCTimestamp = d.getTime() + d.getTimezoneOffset() * 60 * 1000;

							Cookie.set("dr_modal_closed_" + modalID, UTCTimestamp, { expires: 7 });
						}

						modalTrigger.toggleClass("is-active");
						modalWrapper.toggleClass("is-active");
					});
				});
			}
		});
	})(jQuery);
}
